import { ProviderResultItem, ProvidersResponseSetType } from '~/clients';
import { SearchFormData } from '~/components/provider-search';

export type SearchResultType = ProvidersResponseSetType | 'not_supported' | 'rate_limited';

/**
 * Result types describing a search that failed rather than a set of results. These must always
 * outrank display overrides (e.g. `hcsc_compliant`), or the page would fall through to the
 * empty-results state and tell the user to try another search that never ran.
 */
const terminalResultTypes: ReadonlySet<SearchResultType> = new Set(['rate_limited']);

export function isTerminalResultType(resultType: SearchResultType | null): boolean {
  return resultType !== null && terminalResultTypes.has(resultType);
}

export type SearchResults = {
  providers: ProviderResultItem[];
  resultType?: SearchResultType;
};

export type NullableSearchResults = SearchResults | null;

export type UseSearchFormResultsParams = {
  formData: SearchFormData | null;
  showAdditionalProviders: boolean;
};
